import React from 'react'

const RMIcon = () => {
  return (
    <svg version="1.1" id="Capa_1" fill="#A5A3AE"
	 width="16" height="17" viewBox="0 0 74.701 74.701">
		<g>
			<g>
				<path d="M74.674,16.881c0-0.716-0.585-1.299-1.301-1.299h-6.762c-0.541,0-1.031,0.342-1.219,0.85l-7.317,19.875
					c-1.326,3.757-2.353,6.873-3.168,9.613c-0.786-2.765-1.771-5.879-3.031-9.613L44.871,16.45c-0.182-0.52-0.675-0.867-1.225-0.867
					h-6.762c-0.714,0-1.298,0.581-1.3,1.296l-0.095,41.061c0,0.351,0.135,0.677,0.38,0.916c0.245,0.248,0.573,0.383,0.92,0.383
					l4.191,0.001v-0.622l0.015,0.621c0.717,0,1.3-0.582,1.3-1.299c0-0.088-0.008-0.174-0.025-0.262l-0.006-26.354
					c0.666,2.159,1.435,4.534,2.346,7.236l6.675,19.557c0.18,0.523,0.675,0.878,1.229,0.878h4.021c0.546,0,1.037-0.345,1.22-0.856
					l7.217-19.916c1.051-2.875,1.989-5.557,2.838-8.108l-0.008,27.825c0,0.348,0.135,0.674,0.381,0.918
					c0.244,0.246,0.569,0.381,0.916,0.381H73.4c0.349,0,0.674-0.135,0.918-0.381c0.248-0.245,0.383-0.57,0.383-0.918L74.674,16.881z"
					/>
				<path d="M21.456,39.226c4.137-3.471,5.685-6.688,5.685-11.729c0-3.449-1.249-6.448-3.51-8.442
					c-2.746-2.483-6.631-3.593-12.599-3.593L0.58,15.496C0.259,15.497,0,15.758,0,16.077v42.47c0,0.321,0.259,0.582,0.582,0.582h5.444
					c0.322,0,0.58-0.261,0.58-0.582V40.849h8.795l6.479,17.896c0.083,0.23,0.301,0.385,0.546,0.385h5.634
					c0.192,0,0.369-0.095,0.479-0.25c0.106-0.156,0.132-0.357,0.066-0.535L21.456,39.226z M11.598,35.555H6.607V20.824l4.8-0.005
					c4.166,0.046,9.125,1.351,9.125,7.306C20.532,32.64,17.026,35.555,11.598,35.555z"/>
			</g>
		</g>
	</svg>
  )
}

export default RMIcon